import { pipe } from './pipe';
var Property = /** @class */ (function () {
    function Property() {
    }
    Property.prototype.pipe = function () {
        var fns = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            fns[_i] = arguments[_i];
        }
        return pipe.apply(void 0, fns)(this);
    };
    return Property;
}());
export { Property };
//# sourceMappingURL=Property.js.map